import React, {Component} from 'react';
import _ from 'lodash';
import {NavLink} from "react-router-dom";

class TaskDetail extends Component {
	render() {
		return <div className="columns">
			<div className="column is-6">
				<ul className="task-steps">
				{_.map(this.props.data, (task, key) => {
					return <li key={`step-${key}`} className={`task-steps--details ${task.finished ? 'complete' : ''} ${task.locked ? 'locked' : ''} ${this.state.step === task.step ? 'selected' : ''}`} onClick={() => this.showTaskDetail(task.step)}>
						<div className={`step ${this.props.category}`}>
							<p>{task.step}</p>
						</div>
						<div className="info">
							<h3>{task.title}</h3>
						</div>
					</li>
				})}
				</ul>
			</div>
			<div className="column is-5 is-offset-1">
				{!_.isEmpty(this.state.data) &&
				<div className="task-info">
					{!_.isEmpty(this.state.data.role) &&
					<div className="role">
						<p>{this.state.data.role.name} {this.state.data.role.slug === 'promotora' ? <small className="has-text-success">(¡eres tú!)</small> : ''}</p>
					</div>
					}

					<div className="desc content" dangerouslySetInnerHTML={{__html: this.state.data.description}} />

					{!_.isEmpty(this.state.data.output) &&
					<div className="output">
						<ul>
							{_.map(this.state.data.output, (out, o) => {
								return <li key={`task-output-${o}`}>
									<NavLink to={`${this.props.parent}/${out.type}/${this.state.data.id}`} className={`${out.finished ? 'complete' : ''}`}>{out.name}</NavLink>
								</li>
							})}
						</ul>
					</div>
					}

					{!_.isEmpty(this.state.data.files) &&
					<div className="files">
						<ul>
							{_.map(this.state.data.files, (file, f) => {
								return <li key={`task-file-${f}`}>
									<a href={file.file} download={file.name}>{file.name}</a>
								</li>
							})}
						</ul>
					</div>
					}
				</div>}
			</div>
		</div>
	}

	constructor() {
		super();
		this.state = {
			step: undefined,
			data: {}
		}
	}

	showTaskDetail (step) {
		return this.setState({
			step,
			data: _.find(this.props.data, {step: step})
		})
	}
}

export default TaskDetail;


// WEBPACK FOOTER //
// ./src/cdm-frontend/elements/task_detail.jsx